module.exports = __webpack_public_path__ + "media/img/corporate/logos/vz-210316c8c3b8138c97280981d1aef1d9.svg";